export const VEG_WEEK_DAYS_GLOBAL = [
  {
    title: 'Day 1 — Mediterranean bowl day',
    meals: [
      'Breakfast: Greek yogurt parfait (berries, honey, pumpkin seeds) + whole-grain toast',
      'Snack: Apple + 2 tbsp almond butter',
      'Lunch: Quinoa bowl with chickpeas, cucumber, tomato, feta, olive oil, and lemon',
      'Afternoon snack: Carrots + hummus',
      'Dinner: Lentil soup + side salad + 1 slice whole-grain bread',
      'Evening (optional): Handful of walnuts + orange',
    ],
  },
  {
    title: 'Day 2 — Protein-forward start',
    meals: [
      'Breakfast: Vegetable omelette (2–3 eggs) + sautéed spinach + ½ avocado',
      'Snack: Cottage cheese + pineapple',
      'Lunch: Black bean burrito bowl (rice, beans, salsa, lettuce, corn, light cheese)',
      'Afternoon snack: Banana + plain yogurt',
      'Dinner: Tofu stir-fry (soy-ginger) + brown rice + steamed broccoli',
      'Evening: Herbal tea + dark chocolate square (optional)',
    ],
  },
  {
    title: 'Day 3 — Hearty grain day',
    meals: [
      'Breakfast: Overnight oats (oats, milk or plant milk, chia, banana, cinnamon)',
      'Snack: Unsalted trail mix',
      'Lunch: Whole-wheat wrap with hummus, grilled halloumi or paneer, lettuce, and tomato',
      'Afternoon snack: Rice cakes + peanut butter',
      'Dinner: Chickpea and vegetable curry (light oil) + basmati rice + cucumber salad',
      'Evening: Warm milk or fortified plant milk (optional)',
    ],
  },
  {
    title: 'Day 4 — Fresh & light',
    meals: [
      'Breakfast: Smoothie (spinach, banana, milk, peanut butter, optional protein powder)',
      'Snack: Hard-boiled egg (2) + cherry tomatoes',
      'Lunch: Minestrone or vegetable soup + whole-grain roll + side salad',
      'Afternoon snack: Pear + string cheese or plant-based cheese',
      'Dinner: Baked sweet potato + black beans + sautéed greens',
      'Evening: Kefir or yogurt + berries',
    ],
  },
  {
    title: 'Day 5 — Batch-prep friendly',
    meals: [
      'Breakfast: Scrambled eggs with peppers and onion + 1 whole-grain tortilla',
      'Snack: Orange + handful of almonds',
      'Lunch: Buddha bowl—brown rice, roasted vegetables, chickpeas, tahini-lemon dressing',
      'Afternoon snack: Greek yogurt + granola (low sugar)',
      'Dinner: Vegetable pasta (whole wheat) with marinara + side salad',
      'Evening: Protein shake or yogurt + fruit if hungry',
    ],
  },
  {
    title: 'Day 6 — Weekend brunch style',
    meals: [
      'Breakfast: Avocado toast on sourdough + poached eggs + tomatoes',
      'Snack: Edamame or roasted chickpeas',
      'Lunch: Caprese salad (tomato, mozzarella, basil) + lentil side + olive oil',
      'Afternoon snack: Popcorn (air-popped) + fruit',
      'Dinner: Grilled vegetable skewers + couscous + tzatziki',
      'Evening: Herbal tea + dates',
    ],
  },
  {
    title: 'Day 7 — Reset & prep',
    meals: [
      'Breakfast: Pancakes (whole-grain mix) + berries + side of eggs',
      'Snack: Smoothie—milk, cocoa, banana, spinach',
      'Lunch: Leftover grain bowl or soup from batch prep',
      'Afternoon snack: Nuts + dried fruit (small portion)',
      'Dinner: Stir-fried vegetables + tofu or tempeh + jasmine rice',
      'Treat (optional): One small planned dessert—enjoy without guilt',
    ],
  },
];

export const NONVEG_WEEK_DAYS_GLOBAL = [
  {
    title: 'Day 1 — Lean chicken plate',
    meals: [
      'Breakfast: 3-egg veggie scramble + whole-grain toast + berries',
      'Snack: Greek yogurt + honey',
      'Lunch: Grilled chicken breast (150 g) + quinoa + mixed salad + olive oil dressing',
      'Afternoon snack: Banana + handful of almonds',
      'Dinner: Baked salmon (120 g) + roasted potatoes + steamed green beans',
      'Evening (optional): Chocolate milk or protein shake',
    ],
  },
  {
    title: 'Day 2 — Fish & greens',
    meals: [
      'Breakfast: Oatmeal with banana, walnuts, and milk + 1 boiled egg',
      'Snack: Apple + cheese stick',
      'Lunch: Tuna or salmon salad (light mayo or yogurt) on whole-grain bread + side fruit',
      'Afternoon snack: Carrots + hummus',
      'Dinner: Chicken stir-fry (breast, peppers, broccoli) + brown rice',
      'Evening: Warm herbal tea (optional)',
    ],
  },
  {
    title: 'Day 3 — Balanced energy',
    meals: [
      'Breakfast: Yogurt parfait + granola + berries + 1 boiled egg',
      'Snack: Trail mix (unsalted)',
      'Lunch: Turkey or chicken whole-wheat wrap with lettuce, tomato, and mustard',
      'Afternoon snack: Rice cakes + almond butter',
      'Dinner: White fish baked with lemon + sweet potato + side salad',
      'Evening: Cottage cheese + pineapple',
    ],
  },
  {
    title: 'Day 4 — Soup & sandwich',
    meals: [
      'Breakfast: Avocado toast + 2 poached eggs',
      'Snack: Orange + nuts',
      'Lunch: Lentil or chicken vegetable soup + whole-grain roll',
      'Afternoon snack: Protein smoothie (milk, banana, peanut butter)',
      'Dinner: Lean beef or turkey chili (beans, tomatoes) + side salad',
      'Evening: Yogurt + berries',
    ],
  },
  {
    title: 'Day 5 — Grill night',
    meals: [
      'Breakfast: Smoothie (milk, spinach, banana, protein powder)',
      'Snack: Hard-boiled eggs (2) + cherry tomatoes',
      'Lunch: Grilled chicken salad (greens, chickpeas, olive oil, lemon)',
      'Afternoon snack: Banana + peanut butter',
      'Dinner: Grilled shrimp or chicken skewers + couscous + grilled zucchini',
      'Evening: Handful of almonds',
    ],
  },
  {
    title: 'Day 6 — Family-style plate',
    meals: [
      'Breakfast: Whole-grain waffles + side of eggs + fruit',
      'Snack: Edamame',
      'Lunch: Brown rice + black beans + rotisserie chicken (skin removed, 120 g) + salsa',
      'Afternoon snack: Popcorn + fruit',
      'Dinner: Baked cod or tilapia + roasted vegetables + small pasta portion',
      'Evening: Buttermilk or kefir (optional)',
    ],
  },
  {
    title: 'Day 7 — Prep & reset',
    meals: [
      'Breakfast: Protein smoothie + whole-grain toast',
      'Snack: Dates + walnuts',
      'Lunch: Buddha bowl—rice, chickpeas, grilled chicken, tahini dressing',
      'Afternoon snack: Yogurt + granola',
      'Dinner: Vegetable soup + side salad + whole-grain bread',
      'Treat (optional): One small planned dessert portion',
    ],
  },
];

export function activeDayEatingTableGlobal(isVegetarian) {
  const lunchExample = isVegetarian
    ? 'Legumes or eggs, whole grains, vegetables, salad'
    : 'Lean protein, whole grains, vegetables, salad';
  return {
    type: 'table',
    title: 'Busy or active days — simple timing',
    intro:
      'Use this on long workdays, training days, or travel weeks—keep familiar foods and steady portions.',
    headers: ['Timing', 'What to eat', 'Notes'],
    rows: [
      ['Morning', 'Protein + whole grain + fruit', 'Same breakfast rhythm all week when possible'],
      ['Midday', lunchExample, 'Largest balanced meal for many people'],
      ['Afternoon', 'Fruit, yogurt, or nuts', 'Light; skip heavy fried snacks'],
      ['Dinner', 'Vegetables + protein + moderate starch', 'Finish eating 2–3 hours before bed if you can'],
      ['Hydration', 'Water through the day', 'Extra fluids in hot weather or after exercise'],
    ],
  };
}
